/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSettingDefinitionFromJSON, StreemApiSettingDefinitionToJSON, } from './';
export function StreemApiGetSettingDefinitionResponseFromJSON(json) {
    return StreemApiGetSettingDefinitionResponseFromJSONTyped(json, false);
}
export function StreemApiGetSettingDefinitionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'settingDefinition': !exists(json, 'setting_definition') ? undefined : StreemApiSettingDefinitionFromJSON(json['setting_definition']),
    };
}
export function StreemApiGetSettingDefinitionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'setting_definition': StreemApiSettingDefinitionToJSON(value.settingDefinition),
    };
}
//# sourceMappingURL=StreemApiGetSettingDefinitionResponse.js.map